import { createContext } from 'react'

const buynowContext = createContext()

export default buynowContext
